// extracted by css-extract-rspack-plugin
export default {"cls1":"ProgressivePreviewList-cls1_E9W","cls2":"ProgressivePreviewList-cls2_LGk ProgressivePreviewList-cls1_E9W"};